import { OmitType } from "@nestjs/swagger";
import { StudyTranslatableFieldsDto, StudyTranslationLanguage, } from "healthex-common/study.dtos";
import { asEnum, deepCopy, isKeyOfObject, omit, withoutUndefinedOrNullProperties, withoutUndefinedProperties } from "healthex-common/utils";
import Papa from "papaparse";
import { ProjectSectionName, ProjectSectionType } from "healthex-common/project.data.dtos";
export const forceExcludedPropertiesForTranslationDocumentList = ["id", "studyId", "timelineVisitDescriptions", "timelineVisitPeriods"];
export class TranslationsDto extends OmitType(StudyTranslatableFieldsDto, [
    "compositeUpdatedAt",
    "futureUseOfData",
    "hipaaOrganizationLegalName",
    "larInformedConsentStatement",
    "larInstructions",
    "larParticipantAssentStatement",
    "larParticipantAssentTitle",
    "larParticipantExemptFromAssentText",
    "larParticipantInstructions",
    "larParticipantTitle",
    "larSignatureTitle",
    "larTitle",
    "enrollmentTranscodeId",
    "sensitiveDataTitle",
    "purposeOfDataDisclosure",
    "purposeOfDataDisclosureOther",
]) {
}
export const translationReference = {
    loginTitle: "",
    loginText: "",
    patientFriendlyTitle: "",
    welcomeTitle: "",
    welcomeText: "",
    dataUpdateWelcomeTitle: "",
    dataUpdateWelcomeText: "",
    californiaBillOfRightsTitle: "",
    californiaBillOfRightsText: "",
    studyInformationTitle: "",
    enrollmentVideo: null,
    patientFriendlySummary: "",
    purposeOfDataTitle: "",
    purposeOfDataBriefEducation: "",
    informedConsentIRBApprovalStamp: "",
    purposeOfResearchTitle: "",
    purposeOfResearchText: "",
    lengthOfStudyNumberOfParticipantsTitle: "",
    lengthOfStudyNumberOfParticipantsText: "",
    healthRecordUpdatesTitle: "",
    healthRecordUpdatesText: "",
    proceduresAndInterventionsTitle: "",
    proceduresAndInterventionsText: "",
    timelineTitle: "",
    risksTitle: "",
    risksOfEnrollment: "",
    benefitsTitle: "",
    benefitsOfEnrollment: "",
    voluntaryParticipationTitle: "",
    voluntaryParticipationText: "",
    alternativesToParticipation: "",
    withdrawalImplicationsTitle: "",
    leavingStudyEarlyText: "",
    injuryProtocolTitle: "",
    injuryProtocolText: "",
    participationTerminationTitle: "",
    participationTerminationText: "",
    dataTypesTitle: "",
    sensitiveDataText: "",
    futureUseOfDataTitle: "",
    futureUseOfDataText: "",
    confidentialityMeasuresTitle: "",
    confidentialityOfDataText: "",
    compensationTitle: "",
    compensationText: "",
    costTitle: "",
    costOfParticipationText: "",
    researchResultsTitle: "",
    sharingResultsText: "",
    whoToContactTitle: "",
    whoToContactText: "",
    informedConsentTitle: "",
    informedConsentText: "",
    informedConsentYesText: "",
    informedConsentNoText: "",
    informedConsentInterestedText: "",
    hipaaTitle: "",
    hipaaText: "",
    hipaaAuthorizationText: "",
    participantTitle: "",
    participantInstructionsForGuidedConsent: "",
    informedConsentStatement: "",
    parentGuardianTitle: "",
    parentGuardianInstructions: "",
    parentGuardianSignatureTitle: "",
    parentGuardianInformedConsentStatement: "",
    additionalParentGuardianTitle: "",
    additionalParentGuardianInstructions: "",
    additionalParentGuardianExemptSignatureText: "",
    additionalParentGuardianSignatureTitle: "",
    additionalParentGuardianInformedConsentStatement: "",
    minorParticipantTitle: "",
    minorParticipantInstructions: "",
    minorParticipantExemptFromAssentText: "",
    minorParticipantAssentTitle: "",
    minorParticipantAssentStatement: "",
    witnessTitle: "",
    witnessInstructions: "",
    witnessSignatureTitle: "",
    witnessConfirmation: "",
    providerTitle: "",
    providerInstructions: "",
    providerSignatureTitle: "",
    providerConfirmation: "",
    thankYouConsentedTitle: "",
    thankYouConsentedText: "",
    dataUpdateThankYouConsentedTitle: "",
    dataUpdateThankYouConsentedText: "",
    thankYouDeclinedTitle: "",
    thankYouDeclinedText: "",
    thankYouImInterestedTitle: "",
    thankYouImInterestedText: "",
    introTitle: "",
    introPurposeOfDisclosure: "",
    introBriefEducation: "",
    patientHealthRecordRightsTitle: "",
    contactDetails: "",
};
export const translationInputReference = {
    loginTitle: "",
    loginText: "",
    welcomeTitle: "",
    welcomeText: "",
    dataUpdateWelcomeTitle: "",
    dataUpdateWelcomeText: "",
    californiaBillOfRightsTitle: "",
    californiaBillOfRightsText: "",
    studyInformationTitle: "",
    enrollmentVideo: null,
    deleteEnrollmentTranscode: null,
    purposeOfResearchTitle: "",
    lengthOfStudyNumberOfParticipantsTitle: "",
    lengthOfStudyNumberOfParticipantsText: "",
    healthRecordUpdatesTitle: "",
    healthRecordUpdatesText: "",
    proceduresAndInterventionsTitle: "",
    timelineTitle: "",
    benefitsTitle: "",
    risksTitle: "",
    voluntaryParticipationTitle: "",
    voluntaryParticipationText: "",
    withdrawalImplicationsTitle: "",
    injuryProtocolTitle: "",
    participationTerminationTitle: "",
    dataTypesTitle: "",
    sensitiveDataText: "",
    futureUseOfDataTitle: "",
    confidentialityMeasuresTitle: "",
    compensationTitle: "",
    costTitle: "",
    researchResultsTitle: "",
    whoToContactTitle: "",
    whoToContactText: "",
    informedConsentTitle: "",
    informedConsentText: "",
    informedConsentYesText: "",
    informedConsentNoText: "",
    informedConsentInterestedText: "",
    hipaaTitle: "",
    hipaaText: "",
    thankYouConsentedTitle: "",
    thankYouConsentedText: "",
    dataUpdateThankYouConsentedTitle: "",
    dataUpdateThankYouConsentedText: "",
    thankYouDeclinedTitle: "",
    thankYouDeclinedText: "",
    thankYouImInterestedTitle: "",
    thankYouImInterestedText: "",
    parentGuardianTitle: "",
    parentGuardianInstructions: "",
    parentGuardianSignatureTitle: "",
    parentGuardianInformedConsentStatement: "",
    additionalParentGuardianTitle: "",
    additionalParentGuardianInstructions: "",
    additionalParentGuardianExemptSignatureText: "",
    additionalParentGuardianSignatureTitle: "",
    additionalParentGuardianInformedConsentStatement: "",
    minorParticipantTitle: "",
    minorParticipantInstructions: "",
    minorParticipantExemptFromAssentText: "",
    minorParticipantAssentTitle: "",
    minorParticipantAssentStatement: "",
    participantTitle: "",
    participantInstructionsForGuidedConsent: "",
    informedConsentStatement: "",
    witnessTitle: "",
    witnessInstructions: "",
    witnessSignatureTitle: "",
    witnessConfirmation: "",
    providerTitle: "",
    providerInstructions: "",
    providerSignatureTitle: "",
    providerConfirmation: "",
    patientFriendlyTitle: "",
    patientFriendlySummary: "",
    purposeOfDataTitle: "",
    purposeOfDataBriefEducation: "",
    informedConsentIRBApprovalStamp: "",
    risksOfEnrollment: "",
    benefitsOfEnrollment: "",
    leavingStudyEarlyText: "",
    injuryProtocolText: "",
    participationTerminationText: "",
    futureUseOfDataText: "",
    confidentialityOfDataText: "",
    compensationText: "",
    costOfParticipationText: "",
    sharingResultsText: "",
    alternativesToParticipation: "",
    hipaaAuthorizationText: "",
    proceduresAndInterventionsText: "",
    purposeOfResearchText: "",
    informedConsentPrimaryDiseaseOrConditions: [],
    timelineVisits: [],
    additionalSections: [],
    sectionImages: [],
    contactDetails: "",
    introTitle: "",
    introPurposeOfDisclosure: "",
    introBriefEducation: "",
    patientHealthRecordRightsTitle: "",
};
const delimiter = ",";
function escapeTranslation(text) {
    if (text.includes(",") || text.includes('"') || text.includes("\n")) {
        return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
}
export function getTranslatableSectionsFromProjectSections(sections) {
    return sections.filter((section) => {
        return (!(section.sectionType === ProjectSectionType.OPTIONAL && !section.sectionIncludeFieldValue) &&
            section.fields.some((field) => field.translatableFieldNames && field.translatableFieldNames.length > 0));
    });
}
export function getTranslatableFieldsFromProjectSections(sections, filterSections = true) {
    return (filterSections ? getTranslatableSectionsFromProjectSections(sections) : sections).flatMap((section) => section.fields.filter((field) => field.isFieldIncluded).flatMap((field) => { var _a; return (_a = field.translatableFieldNames) !== null && _a !== void 0 ? _a : []; }));
}
function removeUneededFields(fieldsToTranslate, availableTranslatableFields) {
    Object.keys(fieldsToTranslate).forEach((key) => {
        if (!availableTranslatableFields.includes(key)) {
            delete fieldsToTranslate[key];
        }
    });
}
export function getTranslatableFieldsFromStudy(study, availableTranslatableFields, language) {
    const translatableFieldsWithMetadataDto = study.studyTranslatableFields.find((fields) => fields.language === language);
    if (!translatableFieldsWithMetadataDto)
        return null;
    const fieldsToTranslate = omit(translatableFieldsWithMetadataDto, "language", "importType", "enabled", "completed", "compositeUpdatedAt", "futureUseOfData", "hipaaOrganizationLegalName", "parentGuardianSignatureTitle", "larInformedConsentStatement", "larInstructions", "larParticipantAssentStatement", "larParticipantAssentTitle", "larParticipantExemptFromAssentText", "larParticipantInstructions", "larParticipantTitle", "larSignatureTitle", "larTitle");
    removeUneededFields(fieldsToTranslate, availableTranslatableFields);
    return withoutUndefinedOrNullProperties(fieldsToTranslate);
}
export function getNumberOfTranslatableFieldsForLanguage(study, availableTranslatableFields, language) {
    var _a, _b, _c, _d;
    const studyCopy = deepCopy(study);
    const translatableFields = (_a = getTranslatableFieldsFromStudy(studyCopy, availableTranslatableFields, language)) !== null && _a !== void 0 ? _a : {};
    const additionalSections = (_c = (_b = studyCopy.additionalSections) === null || _b === void 0 ? void 0 : _b.filter((section) => section.included && section.language === language)) !== null && _c !== void 0 ? _c : [];
    const sectionImages = (_d = studyCopy.studySectionImages) === null || _d === void 0 ? void 0 : _d.map((image) => image.images).flat().filter((image) => image.language === language && image.caption);
    return getNumberOfTranslatableFields(translatableFields, additionalSections, sectionImages);
}
export function getNumberOfTranslatableFields(studyTranslatableFields, additionalSections, sectionImages) {
    let numberOfTranslatedFields = 0;
    const translatableFields = studyTranslatableFields ? withoutUndefinedProperties(studyTranslatableFields) : undefined;
    if (translatableFields) {
        numberOfTranslatedFields += Object.keys(translatableFields).filter((key) => ![
            "informedConsentPrimaryDiseaseOrConditions",
            "timelineVisits",
            ...forceExcludedPropertiesForTranslationDocumentList,
        ].includes(key)).length;
        if (translatableFields.informedConsentPrimaryDiseaseOrConditions) {
            numberOfTranslatedFields += translatableFields.informedConsentPrimaryDiseaseOrConditions.length;
        }
        if (translatableFields.timelineVisits) {
            numberOfTranslatedFields += translatableFields.timelineVisits.length;
        }
    }
    if (additionalSections) {
        numberOfTranslatedFields += additionalSections.length;
    }
    if (sectionImages) {
        numberOfTranslatedFields += sectionImages.length;
    }
    return numberOfTranslatedFields;
}
export function getNumberOfRequiredTranslatableFields(study, availableTranslatableFields, language) {
    var _a, _b, _c, _d, _e, _f;
    const englishStudy = deepCopy(study);
    const languageStudy = deepCopy(study);
    const englishFields = (_a = getTranslatableFieldsFromStudy(englishStudy, availableTranslatableFields, StudyTranslationLanguage.en)) !== null && _a !== void 0 ? _a : {};
    const languageFields = (_b = getTranslatableFieldsFromStudy(languageStudy, availableTranslatableFields, language)) !== null && _b !== void 0 ? _b : {};
    const englishAdditionalSections = (_c = englishStudy.additionalSections) === null || _c === void 0 ? void 0 : _c.filter((section) => section.language === StudyTranslationLanguage.en && section.included);
    const languageAdditionalSections = (_d = languageStudy.additionalSections) === null || _d === void 0 ? void 0 : _d.filter((section) => section.language === language && section.included);
    const englishSectionImages = (_e = englishStudy.studySectionImages) === null || _e === void 0 ? void 0 : _e.map((image) => image.images).flat().filter((image) => image.language === StudyTranslationLanguage.en && image.caption);
    const languageSectionImages = (_f = languageStudy.studySectionImages) === null || _f === void 0 ? void 0 : _f.map((image) => image.images).flat().filter((image) => image.language === language && image.caption);
    const numberOfEnglishFields = getNumberOfTranslatableFields(englishFields, englishAdditionalSections, englishSectionImages);
    const numberOfLanguageFields = getNumberOfTranslatableFields(languageFields, languageAdditionalSections, languageSectionImages);
    return Math.max(0, numberOfEnglishFields - numberOfLanguageFields);
}
export function getTranslatedStudyText(study, key, currentLanguage) {
    if (!study)
        return "";
    if (currentLanguage !== "en") {
        let studyLanguage;
        switch (currentLanguage) {
            case "es":
                studyLanguage = StudyTranslationLanguage.es;
                break;
            default:
                break;
        }
        if (studyLanguage && study.studyTranslatableFields) {
            const translatedFields = study.studyTranslatableFields.find((field) => field.language === studyLanguage);
            if ((translatedFields === null || translatedFields === void 0 ? void 0 : translatedFields[key]) !== null && (translatedFields === null || translatedFields === void 0 ? void 0 : translatedFields[key]) !== undefined) {
                const value = translatedFields[key];
                if (typeof value === "string" || (Array.isArray(value) && value.every((item) => typeof item === "string"))) {
                    return value;
                }
            }
        }
    }
    const studyValue = study[key];
    if (studyValue &&
        (typeof studyValue === "string" || (Array.isArray(studyValue) && studyValue.every((item) => typeof item === "string")))) {
        return studyValue;
    }
    const originalValue = study[key];
    return Array.isArray(originalValue) ? [] : "";
}
function slugify(value) {
    return value.toString().replace(/_/g, "-");
}
function unslugify(value) {
    return value.replace(/-/g, "_");
}
export function downloadEnglishInformedConsentTranslationsAsCSV(study, availableTranslatableFields, includeTranslations = true) {
    var _a, _b;
    const englishFieldsToTranslate = getTranslatableFieldsFromStudy(study, availableTranslatableFields, StudyTranslationLanguage.en);
    if (!englishFieldsToTranslate)
        return;
    const entries = Object.entries(englishFieldsToTranslate);
    const data = [];
    const translationLanguages = study.studyTranslatableFields
        .filter((fields) => fields.language !== StudyTranslationLanguage.en)
        .map((fields) => fields.language);
    entries.forEach(([key, value]) => {
        if (forceExcludedPropertiesForTranslationDocumentList.includes(key)) {
        }
        else if (value instanceof Array) {
            value.forEach((arrayValue, index) => {
                if (typeof arrayValue === "object" &&
                    "period" in arrayValue &&
                    "description" in arrayValue &&
                    arrayValue.period &&
                    arrayValue.description) {
                    const periodTranslations = [];
                    const descriptionTranslations = [];
                    periodTranslations.push(`timelineVisits_${index + 1}_period`, escapeTranslation(arrayValue.period));
                    descriptionTranslations.push(`timelineVisits_${index + 1}_description`, escapeTranslation(arrayValue.description));
                    if (includeTranslations) {
                        translationLanguages.forEach((language) => {
                            var _a, _b, _c, _d;
                            const translation = (_b = (_a = study.studyTranslatableFields.find((fields) => fields.language === language)) === null || _a === void 0 ? void 0 : _a.timelineVisits) === null || _b === void 0 ? void 0 : _b[index];
                            periodTranslations.push(escapeTranslation((_c = translation === null || translation === void 0 ? void 0 : translation.period) !== null && _c !== void 0 ? _c : ""));
                            descriptionTranslations.push(escapeTranslation((_d = translation === null || translation === void 0 ? void 0 : translation.description) !== null && _d !== void 0 ? _d : ""));
                        });
                    }
                    data.push(periodTranslations);
                    data.push(descriptionTranslations);
                }
                else if (arrayValue && typeof arrayValue === "string" && key === "informedConsentPrimaryDiseaseOrConditions") {
                    const translations = [];
                    translations.push(`${key}_${index + 1}`, escapeTranslation(arrayValue));
                    if (includeTranslations) {
                        translationLanguages.forEach((language) => {
                            var _a, _b;
                            const fieldValue = (_b = (_a = study.studyTranslatableFields.find((fields) => fields.language === language)) === null || _a === void 0 ? void 0 : _a.informedConsentPrimaryDiseaseOrConditions) !== null && _b !== void 0 ? _b : [];
                            const translation = Array.isArray(fieldValue) ? fieldValue[index] : undefined;
                            translations.push(escapeTranslation(translation !== null && translation !== void 0 ? translation : ""));
                        });
                    }
                    data.push(translations);
                }
            });
        }
        else {
            if (value && typeof value === "string") {
                const translations = [];
                translations.push(key, escapeTranslation(value));
                if (includeTranslations && isKeyOfObject(key, translationReference)) {
                    translationLanguages.forEach((language) => {
                        var _a;
                        const translation = (_a = study.studyTranslatableFields.find((fields) => fields.language === language)) === null || _a === void 0 ? void 0 : _a[key];
                        translations.push(escapeTranslation(typeof translation === "string" ? translation : ""));
                    });
                    data.push(translations);
                }
            }
        }
    });
    const sectionImages = deepCopy((_a = study.studySectionImages) !== null && _a !== void 0 ? _a : []);
    const allImages = deepCopy(sectionImages)
        .map((image) => image.images)
        .flat();
    sectionImages.forEach((section) => {
        section.images = section.images.filter((image) => image.language === StudyTranslationLanguage.en);
    });
    const additionalSectionImages = sectionImages
        .filter((section) => section.sectionName === ProjectSectionName.ADDITIONAL_INFORMATION)
        .map((section) => section.images)
        .flat();
    const additionalSections = (_b = study.additionalSections) === null || _b === void 0 ? void 0 : _b.filter((section) => section.language === StudyTranslationLanguage.en);
    additionalSections === null || additionalSections === void 0 ? void 0 : additionalSections.forEach((englishValue, index) => {
        if (englishValue.included) {
            const titleTranslations = [];
            const descriptionTranslations = [];
            titleTranslations.push(`additionalInformation_${index + 1}_title_${englishValue.id}`, escapeTranslation(englishValue.title));
            descriptionTranslations.push(`additionalInformation_${index + 1}_description_${englishValue.id}`, escapeTranslation(englishValue.description));
            if (includeTranslations) {
                translationLanguages.forEach((language) => {
                    var _a, _b, _c;
                    const translation = (_a = study.additionalSections) === null || _a === void 0 ? void 0 : _a.find((translationSection) => translationSection.language === language && translationSection.translatedFrom === englishValue.id);
                    titleTranslations.push(escapeTranslation((_b = translation === null || translation === void 0 ? void 0 : translation.title) !== null && _b !== void 0 ? _b : ""));
                    descriptionTranslations.push(escapeTranslation((_c = translation === null || translation === void 0 ? void 0 : translation.description) !== null && _c !== void 0 ? _c : ""));
                });
            }
            data.push(titleTranslations);
            data.push(descriptionTranslations);
            const images = additionalSectionImages.filter((section) => section.additionalSectionId === englishValue.id);
            images.forEach((image, imageIndex) => {
                if (image.caption) {
                    const translations = [];
                    translations.push(`additionalInformation_${index + 1}_${slugify(image.sectionName)}_${imageIndex + 1}_${image.id}_${image.additionalSectionId}`, escapeTranslation(image.caption));
                    if (includeTranslations) {
                        translationLanguages.forEach((language) => {
                            var _a;
                            const translation = allImages.find((translationImage) => translationImage.language === language && translationImage.translatedFrom === image.id);
                            translations.push(escapeTranslation((_a = translation === null || translation === void 0 ? void 0 : translation.caption) !== null && _a !== void 0 ? _a : ""));
                        });
                    }
                    data.push(translations);
                }
            });
        }
    });
    sectionImages
        .filter((section) => section.sectionName !== ProjectSectionName.ADDITIONAL_INFORMATION)
        .forEach((section) => {
        section.images.forEach((image, index) => {
            if (image.caption) {
                const translations = [];
                translations.push(`${slugify(section.sectionName)}_${index + 1}_${image.id}`, escapeTranslation(image.caption));
                if (includeTranslations) {
                    translationLanguages.forEach((language) => {
                        var _a;
                        const translation = allImages.find((translationImage) => translationImage.language === language && translationImage.translatedFrom === image.id);
                        translations.push(escapeTranslation((_a = translation === null || translation === void 0 ? void 0 : translation.caption) !== null && _a !== void 0 ? _a : ""));
                    });
                }
                data.push(translations);
            }
        });
    });
    const orderAsStrings = availableTranslatableFields.map(String);
    data.sort((a, b) => {
        const aKey = unslugify(a[0].split("_")[0]);
        const bKey = unslugify(b[0].split("_")[0]);
        const aIndex = orderAsStrings.indexOf(aKey);
        const bIndex = orderAsStrings.indexOf(bKey);
        return aIndex - bIndex;
    });
    const languages = translationLanguages.length > 0
        ? translationLanguages
        : Object.keys(StudyTranslationLanguage).filter((language) => language !== StudyTranslationLanguage.en);
    data.unshift(["id", StudyTranslationLanguage.en, ...languages]);
    let csvContent = "";
    data.forEach((row) => {
        csvContent += `${row.join(delimiter)}\n`;
    });
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8," });
    const objUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", objUrl);
    link.setAttribute("download", `study_${study.id}_english`);
    link.textContent = "Click to download";
    link.click();
}
function addTranslationForLanguage(id, translation, translations, additionalSections, timelineVisits, diseaseConditions, sectionImages, language) {
    var _a;
    const idParts = id.split("_");
    if (idParts[2] && ((_a = asEnum(ProjectSectionName)(unslugify(idParts[2]))) === null || _a === void 0 ? void 0 : _a.startsWith("ADDITIONAL_INFORMATION"))) {
        const imageId = idParts[4];
        const additionalSectionId = idParts[5];
        let section = sectionImages.find((imageSection) => imageSection.sectionName === ProjectSectionName.ADDITIONAL_INFORMATION);
        if (!section) {
            sectionImages.push({ sectionName: ProjectSectionName.ADDITIONAL_INFORMATION, images: [] });
            section = sectionImages.find((imageSection) => imageSection.sectionName === ProjectSectionName.ADDITIONAL_INFORMATION);
        }
        const images = section === null || section === void 0 ? void 0 : section.images;
        if (!images)
            return;
        images.push({ id: imageId, additionalSectionId, caption: translation, language });
    }
    else if (asEnum(ProjectSectionName)(unslugify(idParts[0]))) {
        const sectionName = asEnum(ProjectSectionName)(unslugify(idParts[0]));
        if (!sectionName)
            return;
        const imageId = idParts[2];
        let section = sectionImages.find((imageSection) => imageSection.sectionName === sectionName);
        if (!section) {
            sectionImages.push({ sectionName, images: [] });
            section = sectionImages.find((imageSection) => imageSection.sectionName === sectionName);
        }
        const images = section === null || section === void 0 ? void 0 : section.images;
        if (!images)
            return;
        images.push({ id: imageId, caption: translation, language });
    }
    else if (idParts[0] === "additionalInformation") {
        const sectionIndex = parseInt(idParts[1]) - 1;
        const fieldType = idParts[2];
        const additionalSectionId = idParts[3];
        while (additionalSections.length <= sectionIndex) {
            additionalSections.push({ id: additionalSectionId, title: "", description: "" });
        }
        if (fieldType === "title") {
            additionalSections[sectionIndex].title = translation;
        }
        else if (fieldType === "description") {
            additionalSections[sectionIndex].description = translation;
        }
    }
    else if (idParts[0] === "informedConsentPrimaryDiseaseOrConditions") {
        const index = parseInt(idParts[1]) - 1;
        while (diseaseConditions.length <= index) {
            diseaseConditions.push("");
        }
        diseaseConditions[index] = translation;
    }
    else if (idParts[0] === "timelineVisits") {
        const sectionIndex = parseInt(idParts[1]) - 1;
        const fieldType = idParts[2];
        while (timelineVisits.length <= sectionIndex) {
            timelineVisits.push({ description: "", period: "" });
        }
        if (fieldType === "description") {
            timelineVisits[sectionIndex].description = translation;
        }
        else if (fieldType === "period") {
            timelineVisits[sectionIndex].period = translation;
        }
    }
    else if (isKeyOfObject(id, translationReference)) {
        if (id === "enrollmentVideo") {
        }
        else {
            ;
            translations[id] = translation;
        }
    }
    else {
        console.error(`id ${id} does not exist on translation reference`);
    }
}
export function importTranslationsDocument(file, language, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", (e) => {
        var _a;
        const fileContents = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
        if (!(typeof fileContents === "string"))
            return;
        try {
            const parsed = Papa.parse(fileContents, {
                delimiter,
                dynamicTyping: true,
                header: true,
                skipEmptyLines: true,
            });
            const { data } = parsed;
            const translations = {};
            const translatedAdditionalSections = [];
            let translationTimelineVisits = [];
            let translatedDiseaseConditions = [];
            const translatedSectionImages = [];
            const enrollmentVideo = null;
            const prescreenVideo = null;
            const originalEnglish = {};
            const originalEnglishAdditionalSections = [];
            let originalEnglishTimelineVisits = [];
            let originalEnglishDiseaseConditions = [];
            const originalEnglishSectionImages = [];
            for (const row of data) {
                const { id, en, es } = row;
                if (!id || !en)
                    continue;
                let selectedTranslation = "";
                switch (language) {
                    case StudyTranslationLanguage.es:
                        selectedTranslation = es;
                }
                if (selectedTranslation) {
                    addTranslationForLanguage(id, selectedTranslation, translations, translatedAdditionalSections, translationTimelineVisits, translatedDiseaseConditions, translatedSectionImages, language);
                }
                if (en) {
                    addTranslationForLanguage(id, en, originalEnglish, originalEnglishAdditionalSections, originalEnglishTimelineVisits, originalEnglishDiseaseConditions, originalEnglishSectionImages, StudyTranslationLanguage.en);
                }
            }
            translationTimelineVisits = translationTimelineVisits.filter((timelineVisit) => !!timelineVisit.description && !!timelineVisit.period);
            translations.timelineVisits = translationTimelineVisits.length ? translationTimelineVisits : undefined;
            originalEnglishTimelineVisits = originalEnglishTimelineVisits.filter((timelineVisit) => !!timelineVisit.description && !!timelineVisit.period);
            originalEnglish.timelineVisits = originalEnglishTimelineVisits.length ? originalEnglishTimelineVisits : undefined;
            translatedDiseaseConditions = translatedDiseaseConditions.filter((diseaseCondition) => !!diseaseCondition);
            translations.informedConsentPrimaryDiseaseOrConditions = translatedDiseaseConditions.length
                ? translatedDiseaseConditions
                : undefined;
            originalEnglishDiseaseConditions = originalEnglishDiseaseConditions.filter((diseaseCondition) => !!diseaseCondition);
            originalEnglish.informedConsentPrimaryDiseaseOrConditions = originalEnglishDiseaseConditions.length
                ? originalEnglishDiseaseConditions
                : undefined;
            callback({
                translations: {
                    translatableFields: withoutUndefinedProperties(translations),
                    additionalSections: translatedAdditionalSections.filter((section) => !!section.title || !!section.description),
                    sectionImages: translatedSectionImages.filter((section) => !!section.images.length),
                    enrollmentVideo,
                    prescreenVideo,
                },
                originalEnglish: {
                    translatableFields: withoutUndefinedProperties(originalEnglish),
                    additionalSections: originalEnglishAdditionalSections.filter((section) => !!section.title || !!section.description),
                    sectionImages: originalEnglishSectionImages.filter((section) => !!section.images.length),
                    enrollmentVideo,
                    prescreenVideo,
                },
                language,
            });
        }
        catch (error) {
            callback(null);
            console.error("Error importing translations", error);
        }
    });
    reader.readAsText(file, "UTF-8");
}
